import { useState, useEffect } from 'react'
import { Data, DataTypeForm2 } from "../../../../../features/data-types"
import { Modal, ModalId, useUIActions, useUIState, FieldType, FormField } from "../../../../../features/ui"

type Props = {
    onSubmit: (note: string) => void
}

export const AddNoteModal = ({ onSubmit }: Props) => {
    const { closeModal } = useUIActions()
    const { openedModal } = useUIState()
    const [resetKey, setResetKey] = useState(0)

    useEffect(() => {
        if (openedModal === ModalId.ADD_NOTE) {
            setResetKey(k => k + 1)
        }
    }, [openedModal])

    const fields: FormField[] = [
        {
            name: 'noteText',
            type: FieldType.LONG_TEXT,
            focus: true,
            defaultValue: '',
            optional: false
        }
    ]

    const handleSubmit = (data: Data) => {
        if (data.noteText) {
            onSubmit(data.noteText as string)
            closeModal(ModalId.ADD_NOTE)
        }
    }

    return (
        <Modal
            modalId={ModalId.ADD_NOTE}
            title="Agregar Nota Interna"
            widthSize="m"
            hideCancel
        >
            <DataTypeForm2
                key={resetKey}
                formId="add-note-form"
                fields={fields}
                createMode={true}
                onSubmit={handleSubmit}
                onCancel={() => closeModal(ModalId.ADD_NOTE)}
            />
        </Modal>
    )
}
